module.exports = __webpack_public_path__ + "static/media/attach_icon.493f624b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductSelector/asstes/attach_icon.jpg
// module id = oHrP
// module chunks = 23